// Decision tree data for Traum-E-Bike Finder (Widget 4)
// Adapted from WLB Master Prompt v3 — TRAUM_EBIKE_TREE
// Each node either has { question, options:[{key,label,icon,blurb}] } or { result:{...} }

window.TREE_DATA = {
  start: {
    id: 'start',
    question: 'Wann nutzt du dein E-Bike überwiegend?',
    subtitle: 'Wir starten mit dem Wichtigsten: deinem Alltag.',
    options: [
      { key: 'alltag',   label: 'Alltag',   icon: 'briefcase', blurb: 'Pendeln, Einkaufen, Stadt.' },
      { key: 'freizeit', label: 'Freizeit', icon: 'compass',   blurb: 'Touren, Sport, Wochenende.' },
    ],
  },

  // ─────────── ALLTAG ───────────
  'start.alltag': {
    id: 'alltag',
    question: 'In welcher Umgebung fährst du am meisten?',
    options: [
      { key: 'stadt', label: 'Stadt',                     icon: 'building',  blurb: 'Asphalt, Ampeln, Radwege.' },
      { key: 'feld',  label: 'Feld- und Waldwege',        icon: 'mountain',  blurb: 'Mix aus Schotter und Stadt.' },
    ],
  },

  'start.alltag.stadt': {
    id: 'alltag-stadt',
    question: 'Wofür nutzt du das Rad hauptsächlich?',
    options: [
      { key: 'kinder', label: 'Kinder & Transport', icon: 'package',  blurb: 'Lasten, Einkauf, Familie.' },
      { key: 'buero',  label: 'Büro & Alltag',      icon: 'briefcase', blurb: 'Pendeln, Termine, leicht.' },
    ],
  },

  'start.alltag.stadt.kinder': {
    id: 'result-cargo',
    result: {
      type: 'Cargo E-Bike',
      tagline: 'Der Familien-Lastenträger.',
      reasoning: [
        'Du transportierst regelmäßig Kinder oder Einkäufe.',
        'Stabiler Rahmen und tiefer Schwerpunkt für Sicherheit.',
        'Drehmomentstarker Mittelmotor für volle Last am Berg.',
      ],
      battery_wh: 572,
      battery_label: 'Cargo: ~572 Wh empfohlen',
      bikes: [
        { brand: 'Tenways', model: 'CARGO ONE', price: 4999, badge: '960 Wh', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_edc56f78-e54c-4609-bedf-15bb204b8e4c.png?v=1776965841', url: 'https://welikebikes.de/products/tenways-cargo-one-1' },
        { brand: 'Butchers & Bicycles', model: 'MK1-E Gen. 3 vario', price: 7200, badge: 'Premium', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_b7724615-1f8d-4fb8-90d2-39a9ba22e271.png?v=1773862388', url: 'https://welikebikes.de/products/butchers-bicycles-mk1-e-gen-3-vario' },
        { brand: 'Tarran', model: 'T1 PRO Beigegrau', price: 6999, badge: 'Long-John', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_4dfd0a7e-79ba-4b29-bd52-62cba59268a6.png?v=1776965816', url: 'https://welikebikes.de/products/tarran-t1-pro-beigegrau' },
      ],
    },
  },

  'start.alltag.stadt.buero': {
    id: 'alltag-stadt-buero',
    question: 'Welche Größe bevorzugst du?',
    options: [
      { key: 'regulaer', label: 'Reguläre Größe', icon: 'bike',     blurb: 'Klassisches Fahrrad, 28 Zoll.' },
      { key: 'kompakt',  label: 'Kompakt',        icon: 'minimize', blurb: '20 Zoll, weniger Platz.' },
    ],
  },

  'start.alltag.stadt.buero.regulaer': {
    id: 'alltag-stadt-buero-regulaer',
    question: 'Welches Design spricht dich an?',
    options: [
      { key: 'modern',     label: 'Modern',     icon: 'zap',     blurb: 'Klare Linien, integriert.' },
      { key: 'klassisch',  label: 'Klassisch',  icon: 'feather', blurb: 'Komfort, Tiefeinsteiger-Optik.' },
    ],
  },

  'start.alltag.stadt.buero.regulaer.modern': {
    id: 'result-urban',
    result: {
      type: 'Urban / City E-Bike',
      tagline: 'Reduziert, schnell, alltagstauglich.',
      reasoning: [
        'Du fährst täglich in der Stadt.',
        'Bevorzugst minimalistisches, modernes Design.',
        'Brauchst keine Lastentransport-Funktionen.',
      ],
      battery_wh: 315,
      battery_label: 'City: ~315 Wh — leicht und alltagstauglich',
      bikes: [
        { brand: 'Vanmoof', model: 'S6', price: 3298, badge: 'Smart', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_065ab87a-078e-481d-8012-ddb76a948580.png?v=1776965908', url: 'https://welikebikes.de/products/vanmoof-s6' },
        { brand: 'Cowboy', model: 'Cruiser ST - Performance', price: 3299, badge: 'App-Drive', image: '', url: 'https://welikebikes.de/products/cowboy-cruiser-st-performance' },
        { brand: 'Tenways', model: 'CGO009', price: 2199, badge: 'Mid-Drive', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_76be1cba-a78f-4fc0-9018-e1553a9e8c64.png?v=1776320103', url: 'https://welikebikes.de/products/tenways-cgo009-1' },
      ],
    },
  },

  'start.alltag.stadt.buero.regulaer.klassisch': {
    id: 'result-trekking-classic',
    result: {
      type: 'Trekkingbike (klassisch) / Tiefeinsteiger',
      tagline: 'Komfortabel und entspannt durch die Stadt.',
      reasoning: [
        'Du legst Wert auf bequemes, aufrechtes Fahren.',
        'Klassische Optik passt zu deinem Stil.',
        'Tiefer Einstieg erleichtert Auf- und Absteigen.',
      ],
      battery_wh: 551,
      battery_label: 'Tiefeinsteiger: ~551 Wh für Reichweite',
      bikes: [
        { brand: 'HNF Nicolai', model: 'SD3 Urban', price: 2999, badge: 'Tiefeinsteiger', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_69f98c4b-cced-4106-86d7-909d069e5396.png?v=1776965599', url: 'https://welikebikes.de/products/hnf-nicolai-sd3-urban-1' },
        { brand: 'KTM', model: 'MACINA STYLE 740', price: 2999, badge: '750 Wh', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_020eb1e8-0820-4a85-8e11-1687602b50fa.png?v=1776965676', url: 'https://welikebikes.de/products/ktm-macina-style-741' },
        { brand: 'Velo de Ville', model: 'CEB 590', price: 3299, badge: 'Komfort', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_25c2f6f4-b128-408d-afd2-ad18a03733a2.png?v=1776965921', url: 'https://welikebikes.de/products/velo-de-ville-ceb-591' },
      ],
    },
  },

  'start.alltag.stadt.buero.kompakt': {
    id: 'alltag-stadt-buero-kompakt',
    question: 'Fährst du oft mit dem Zug?',
    options: [
      { key: 'ja',   label: 'Ja',   icon: 'train', blurb: 'Pendeln im Mix mit ÖPNV.' },
      { key: 'nein', label: 'Nein', icon: 'car',   blurb: 'Auto-Transport oder kleine Wohnung.' },
    ],
  },

  'start.alltag.stadt.buero.kompakt.ja': {
    id: 'result-faltrad',
    result: {
      type: 'Faltrad',
      tagline: 'Brompton, Tern & Co. — Bahn-tauglich.',
      reasoning: [
        'Du kombinierst Rad und Bahn täglich.',
        'Faltrad reist immer kostenlos als Handgepäck.',
        'Passt unter Schreibtisch und in Kofferraum.',
      ],
      battery_wh: 442,
      battery_label: 'Kompakt: ~442 Wh — perfekt für Pendelstrecken',
      train_note: 'Faltrad reist kostenlos in der Bahn als Handgepäck — keine Fahrradkarte nötig.',
      bikes: [
        { brand: 'Sushi', model: 'Maki 3.0+ B-Ware', price: 1000, badge: 'Kompakt', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_3b236cbc-dc6d-4ded-b112-445e285eb2af.png?v=1776965809', url: 'https://welikebikes.de/products/sushi-maki-3-0-b-ware-1' },
        { brand: 'Sushi', model: 'California Roll 3.0+ B-Ware', price: 1000, badge: 'Pendler', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_d4201e09-14a6-41d5-a39c-b3f39953c89c.png?v=1776965802', url: 'https://welikebikes.de/products/sushi-california-roll-3-0-b-ware-1' },
        { brand: 'Tenways', model: 'AGO AIR', price: 2199, badge: 'Leicht', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_62b66228-1335-44bf-bf25-2ba000b615a4.png?v=1776965829', url: 'https://welikebikes.de/products/tenways-ago-air-1' },
      ],
    },
  },

  'start.alltag.stadt.buero.kompakt.nein': {
    id: 'result-kompakt',
    result: {
      type: 'Kompakt E-Bike (20 Zoll)',
      tagline: 'Klein, robust, alltagstauglich.',
      reasoning: [
        'Du brauchst ein platzsparendes Rad.',
        'Faltfunktion ist nicht zwingend.',
        '20-Zoll-Räder reisen kostenlos in der Bahn.',
      ],
      battery_wh: 442,
      battery_label: 'Kompakt: ~442 Wh',
      train_note: '20-Zoll-Räder reisen kostenlos als Handgepäck in der Bahn — auch ohne Falt-Funktion.',
      bikes: [
        { brand: 'Sushi', model: 'Maki 3.0+ B-Ware', price: 1000, badge: '20 Zoll', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_3b236cbc-dc6d-4ded-b112-445e285eb2af.png?v=1776965809', url: 'https://welikebikes.de/products/sushi-maki-3-0-b-ware-1' },
        { brand: 'Sushi', model: 'California Roll 3.0+ B-Ware', price: 1000, badge: 'Pendler', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_d4201e09-14a6-41d5-a39c-b3f39953c89c.png?v=1776965802', url: 'https://welikebikes.de/products/sushi-california-roll-3-0-b-ware-1' },
        { brand: 'Tenways', model: 'AGO AIR', price: 2199, badge: 'Leicht', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_62b66228-1335-44bf-bf25-2ba000b615a4.png?v=1776965829', url: 'https://welikebikes.de/products/tenways-ago-air-1' },
      ],
    },
  },

  'start.alltag.feld': {
    id: 'alltag-feld',
    question: 'Wie weit pendelst du täglich?',
    subtitle: 'Das entscheidet über Geschwindigkeitsklasse und Akku.',
    options: [
      { key: 'kurz', label: 'Bis 15 km',     icon: 'gauge',     blurb: 'Pedelec 25 km/h reicht.' },
      { key: 'lang', label: 'Mehr als 15 km', icon: 'rocket',   blurb: 'S-Pedelec spart Zeit.' },
    ],
  },

  'start.alltag.feld.kurz': {
    id: 'result-suv',
    result: {
      type: 'SUV / E-All-Terrain-Bike',
      tagline: 'Pendeln und Gelände im selben Rad.',
      reasoning: [
        'Dein Weg führt über Asphalt UND Schotter.',
        'Robuste Reifen und Federgabel für Komfort.',
        'Vollausstattung: Licht, Schutzbleche, Gepäckträger.',
      ],
      battery_wh: 684,
      battery_label: 'All-Terrain: ~684 Wh für lange Mix-Touren',
      bikes: [
        { brand: 'HNF Nicolai', model: 'UD4 All-Terrain', price: 4499, badge: 'All-Terrain', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_2ebc99c5-32e1-4e66-9ef9-355b6f9c7eac.png?v=1776965633', url: 'https://welikebikes.de/products/hnf-nicolai-ud4-all-terrain-1' },
        { brand: 'Velo de Ville', model: 'SEB 890', price: 4473, badge: 'Sport-Trekking', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_71624bec-6a5b-4dd8-8b31-395b4089a9f8.png?v=1776965938', url: 'https://welikebikes.de/products/velo-de-ville-seb-890' },
        { brand: 'HNF Nicolai', model: 'UD3 Adventure', price: 4415, badge: 'Adventure', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_4a3d5e4d-9826-4680-adb8-ff5ef372a8a9.png?v=1776965614', url: 'https://welikebikes.de/products/hnf-nicolai-ud3-adventure-2' },
      ],
    },
  },

  'start.alltag.feld.lang': {
    id: 'result-spedelec',
    result: {
      type: 'S-Pedelec (45 km/h)',
      tagline: 'Wenn das Auto ersetzt werden soll.',
      reasoning: [
        'Pendelstrecken über 15 km werden mit 25 km/h zäh.',
        'S-Pedelec halbiert deine Fahrzeit zur Arbeit.',
        'Versicherungspflicht & Helmpflicht — dafür echte Auto-Alternative.',
      ],
      battery_wh: 750,
      battery_label: 'S-Pedelec: ~750 Wh — höhere Geschwindigkeit zieht mehr',
      train_note: 'Achtung: S-Pedelecs dürfen NICHT auf Radwegen fahren — nur Straße.',
      bikes: [
        { brand: 'KTM', model: 'Macina Style 730', price: 3224, badge: 'S-Pedelec', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_935ca749-c4a8-4adb-9bf3-b3bedb7ff1d3.png?v=1776965670', url: 'https://welikebikes.de/products/ktm-macina-style-731' },
        { brand: 'HNF Nicolai', model: 'XD3 Adventure', price: 3311, badge: 'Bosch CX', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_bf327d84-abf4-43bc-b32d-998d925b9249.png?v=1776965639', url: 'https://welikebikes.de/products/hnf-nicolai-xd3-adventure-2' },
        { brand: 'HNF Nicolai', model: 'UD4 Adventure', price: 5490, badge: '750 Wh', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_fecadf2b-9e26-4d98-90ee-7cc77fa1e7a2.png?v=1776965621', url: 'https://welikebikes.de/products/hnf-nicolai-ud4-adventure-1' },
      ],
    },
  },

  // ─────────── FREIZEIT ───────────
  'start.freizeit': {
    id: 'freizeit',
    question: 'In welcher Umgebung fährst du am liebsten?',
    options: [
      { key: 'stadt', label: 'Stadt',                          icon: 'building', blurb: 'Lockere Stadtspaziergänge.' },
      { key: 'feld',  label: 'Feld, Wald oder Berge',          icon: 'mountain', blurb: 'Trail, Schotter, Höhenmeter.' },
    ],
  },

  'start.freizeit.stadt': {
    id: 'freizeit-stadt',
    question: 'Wie sportlich möchtest du fahren?',
    subtitle: 'Cruisen oder Rennrad-Feeling?',
    options: [
      { key: 'gemuetlich', label: 'Gemütlich', icon: 'coffee',   blurb: 'Lifestyle, locker, entspannt.' },
      { key: 'sportlich',  label: 'Sportlich', icon: 'flame',    blurb: 'Tempo, schmale Reifen, Gravel.' },
    ],
  },

  'start.freizeit.stadt.gemuetlich': {
    id: 'result-urban-leisure',
    result: {
      type: 'Urban / City E-Bike',
      tagline: 'Locker, sauber, entspannt.',
      reasoning: [
        'Du fährst hauptsächlich zum Vergnügen in der Stadt.',
        'Wenig Anforderung an Lastentransport.',
        'Stylisches Design ist dir wichtig.',
      ],
      battery_wh: 315,
      battery_label: 'City: ~315 Wh ist mehr als genug',
      bikes: [
        { brand: 'Lemmo', model: 'One MK2 Limited', price: 2999, badge: 'Premium', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_3ad84be2-a3bc-459f-bf87-309a32416ff8.png?v=1771945031', url: 'https://welikebikes.de/products/lemmo-one-mk2-limited' },
        { brand: 'QWIC', model: 'Signal', price: 2399, badge: 'Komfort', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_36840b87-7cfb-43c0-97f9-b455da9715ca.png?v=1776965781', url: 'https://welikebikes.de/products/qwic-signal' },
        { brand: 'Hepha', model: 'Performance', price: 2099, badge: 'Allrounder', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_39a4fc63-79e8-4edd-a846-576211ec2fbd.png?v=1776965592', url: 'https://welikebikes.de/products/hepha-performance-1' },
      ],
    },
  },

  'start.freizeit.stadt.sportlich': {
    id: 'result-egravel',
    result: {
      type: 'E-Gravel / E-Rennrad',
      tagline: 'Drop-Bar, schmale Reifen, agil.',
      reasoning: [
        'Du suchst sportliches Fahrgefühl, auch in der Stadt.',
        'Leichter Rahmen und Drop-Lenker für aerodynamische Position.',
        'Auch für längere Ausfahrten am Wochenende geeignet.',
      ],
      battery_wh: 360,
      battery_label: 'E-Gravel: ~360 Wh — leicht und sportlich',
      bikes: [
        { brand: 'Drag', model: 'Celerra Mho Gravel X20 TE', price: 4777, badge: 'E-Gravel', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_57204e80-de5e-4023-ba39-ed93ef7681df.png?v=1776965573', url: 'https://welikebikes.de/products/drag-celerra-mho-gravel-x20-te' },
        { brand: 'Drag', model: 'Bicycles Sterrato CF G2 6.0 SF', price: 2469, badge: 'Carbon Gravel', image: '', url: 'https://welikebikes.de/products/drag-bicycles-sterrato-cf-g2-6-0-sf' },
        { brand: 'Pinarello', model: 'Granger X5', price: 3713, badge: 'Premium Gravel', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_83bab4d8-4347-4e0d-9660-5ba1e9090292.png?v=1776965755', url: 'https://welikebikes.de/products/pinarello-granger-x5-1' },
      ],
    },
  },

  'start.freizeit.feld': {
    id: 'freizeit-feld',
    question: 'Brauchst du Alltagsausstattung (Licht, Schutzbleche, Gepäckträger)?',
    options: [
      { key: 'ja',   label: 'Ja',   icon: 'check',  blurb: 'Vielseitig nutzbar, auch zum Pendeln.' },
      { key: 'nein', label: 'Nein', icon: 'flame',  blurb: 'Pure Sportgerät, kein Ballast.' },
    ],
  },

  'start.freizeit.feld.ja': {
    id: 'freizeit-feld-ja',
    question: 'Welcher Untergrund überwiegt?',
    subtitle: 'Das entscheidet über Reifen und Geometrie.',
    options: [
      { key: 'asphalt',  label: 'Asphalt & Schotter', icon: 'route',    blurb: 'Trekking-Klassiker.' },
      { key: 'gelaende', label: 'Wald & Trail',       icon: 'mountain', blurb: 'SUV — robuster, breitere Reifen.' },
    ],
  },

  'start.freizeit.feld.ja.asphalt': {
    id: 'result-trekking',
    result: {
      type: 'Trekkingbike',
      tagline: 'Der vielseitige Tour-Klassiker.',
      reasoning: [
        'Asphalt und Schotter sind dein Hauptterrain.',
        'Vollausstattung für mehrtägige Touren.',
        '28-Zoll-Räder mit Tour-Reifen für Effizienz.',
      ],
      battery_wh: 625,
      battery_label: 'Trekking: ~625 Wh für lange Touren',
      bikes: [
        { brand: 'Velo de Ville', model: 'FEB 990 Smart', price: 2650, badge: 'Smart', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_694d7a7a-1840-4192-8ffd-d88ac6f366b1.png?v=1771945301', url: 'https://welikebikes.de/products/velo-de-ville-feb-990-smart-1' },
        { brand: 'KTM', model: 'Macina Gran 720', price: 3224, badge: 'Bosch CX', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_e68dc9e6-3b5f-4a7d-b4b7-2cc93335b2b4.png?v=1776965665', url: 'https://welikebikes.de/products/ktm-macina-gran-721' },
        { brand: 'HNF Nicolai', model: 'UD3 Adventure 22', price: 2208, badge: '625 Wh', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_e9562774-47e9-4824-819b-6c94df28d3a5.png?v=1776965606', url: 'https://welikebikes.de/products/hnf-nicolai-ud3-adventure-23' },
      ],
    },
  },

  'start.freizeit.feld.ja.gelaende': {
    id: 'result-suv-tour',
    result: {
      type: 'SUV E-Bike',
      tagline: 'Touring trifft Trail.',
      reasoning: [
        'Wald- und Trailwege bestimmen deinen Fahralltag.',
        'Robuste 27,5-Zoll-Reifen mit Profil.',
        'Federgabel + voller Vollausstattung.',
      ],
      battery_wh: 750,
      battery_label: 'SUV: ~750 Wh — Reserve fürs Gelände',
      bikes: [
        { brand: 'HNF Nicolai', model: 'UD4 All-Terrain', price: 4499, badge: 'All-Terrain', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_2ebc99c5-32e1-4e66-9ef9-355b6f9c7eac.png?v=1776965633', url: 'https://welikebikes.de/products/hnf-nicolai-ud4-all-terrain-1' },
        { brand: 'HNF Nicolai', model: 'UD4 Adventure', price: 5490, badge: 'Premium', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_fecadf2b-9e26-4d98-90ee-7cc77fa1e7a2.png?v=1776965621', url: 'https://welikebikes.de/products/hnf-nicolai-ud4-adventure-1' },
        { brand: 'Velo de Ville', model: 'FEB 990 Smart', price: 2650, badge: 'Smart-Tourer', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_694d7a7a-1840-4192-8ffd-d88ac6f366b1.png?v=1771945301', url: 'https://welikebikes.de/products/velo-de-ville-feb-990-smart-1' },
      ],
    },
  },

  'start.freizeit.feld.nein': {
    id: 'freizeit-feld-nein',
    question: 'Hardtail oder Fully?',
    subtitle: 'Federung vorne — oder vorne und hinten?',
    options: [
      { key: 'hardtail', label: 'Hardtail',       icon: 'minus',    blurb: 'Leichter, günstiger, effizient.' },
      { key: 'fully',    label: 'Full-Suspension', icon: 'activity', blurb: 'Mehr Komfort, Trail & Enduro.' },
    ],
  },

  'start.freizeit.feld.nein.hardtail': {
    id: 'result-emtb-hardtail',
    result: {
      type: 'E-MTB Hardtail',
      tagline: 'Cross-Country & leichte Trails.',
      reasoning: [
        'Federgabel vorne, starrer Hinterbau — leichter und effizienter.',
        'Ideal für XC, Schotter und leichte Trails.',
        'Geringerer Wartungsaufwand, ~30 % günstiger als Fully.',
      ],
      battery_wh: 625,
      battery_label: 'E-MTB Hardtail: ~625 Wh für Tagestouren',
      bikes: [
        { brand: 'Drag', model: 'ION 7.1', price: 3898, badge: 'Hardtail', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_7b44749d-b25c-4583-9b67-a732d1fd8cc4.png?v=1776965580', url: 'https://welikebikes.de/products/drag-ion-7-2' },
        { brand: 'HNF Nicolai', model: 'UD3 Adventure', price: 4415, badge: 'All-Mountain', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_4a3d5e4d-9826-4680-adb8-ff5ef372a8a9.png?v=1776965614', url: 'https://welikebikes.de/products/hnf-nicolai-ud3-adventure-2' },
        { brand: 'Velo de Ville', model: 'SEB 890', price: 4473, badge: 'Sport', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_71624bec-6a5b-4dd8-8b31-395b4089a9f8.png?v=1776965938', url: 'https://welikebikes.de/products/velo-de-ville-seb-890' },
      ],
    },
  },

  'start.freizeit.feld.nein.fully': {
    id: 'result-emtb-fully',
    result: {
      type: 'E-MTB Full-Suspension',
      tagline: 'Pures Trail-Vergnügen, mit Boost.',
      reasoning: [
        'Federung vorne und hinten — maximaler Komfort und Traktion.',
        'Schont Rücken und Knie auf langen Abfahrten.',
        'Drehmoment und 150-mm-Federweg für technische Trails.',
      ],
      battery_wh: 720,
      battery_label: 'E-MTB Fully: ~720 Wh für Höhenmeter-Touren',
      bikes: [
        { brand: 'Velo de Ville', model: 'SEB 890', price: 4473, badge: 'Trail', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_71624bec-6a5b-4dd8-8b31-395b4089a9f8.png?v=1776965938', url: 'https://welikebikes.de/products/velo-de-ville-seb-890' },
        { brand: 'HNF Nicolai', model: 'UD4 All-Terrain', price: 4499, badge: 'All-Terrain', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_2ebc99c5-32e1-4e66-9ef9-355b6f9c7eac.png?v=1776965633', url: 'https://welikebikes.de/products/hnf-nicolai-ud4-all-terrain-1' },
        { brand: 'Drag', model: 'ION 7.1', price: 3898, badge: 'Hardtail-Alternative', image: 'https://cdn.shopify.com/s/files/1/0645/8933/2716/files/image_7b44749d-b25c-4583-9b67-a732d1fd8cc4.png?v=1776965580', url: 'https://welikebikes.de/products/drag-ion-7-2' },
      ],
    },
  },
};

// Crumb labels — what the user picked at each step, in order
window.TREE_LABELS = {
  alltag: 'Alltag',
  freizeit: 'Freizeit',
  stadt: 'Stadt',
  feld: 'Feld & Wald',
  kinder: 'Kinder & Transport',
  buero: 'Büro & Alltag',
  regulaer: 'Reguläre Größe',
  kompakt: 'Kompakt',
  modern: 'Modern',
  klassisch: 'Klassisch',
  ja: 'Ja',
  nein: 'Nein',
  kurz: 'Bis 15 km',
  lang: 'Über 15 km',
  gemuetlich: 'Gemütlich',
  sportlich: 'Sportlich',
  asphalt: 'Asphalt',
  gelaende: 'Gelände',
  hardtail: 'Hardtail',
  fully: 'Full-Suspension',
};
